import { render, staticRenderFns } from "./VideosField.vue?vue&type=template&id=d1c2d476&scoped=true"
import script from "./VideosField.vue?vue&type=script&lang=ts"
export * from "./VideosField.vue?vue&type=script&lang=ts"
import style0 from "./VideosField.vue?vue&type=style&index=0&id=d1c2d476&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c2d476",
  null
  
)

export default component.exports